// extracted by mini-css-extract-plugin
export default {"reportItem":"ReportItem_reportItem__NTTg2","name":"ReportItem_name__KHQWC","descr":"ReportItem_descr__X2s2q"};